<template>
    <Card class="quickpay-pitch">
        <div class="quickpay-pitch__text">
            <p class="quickpay-pitch__title typographies-display-brand-small">
                {{ translations.title }}
            </p>
            <p class="quickpay-pitch__description typographies-paragraph-medium-regular">
                <TranslationText :parts="descriptionParts" />
            </p>
        </div>
        <div class="quickpay-pitch__preview">
            <VideoPreview :thumbnailSrc="illustrationSrc" :videoUrl="videoUrl" />
        </div>
    </Card>
</template>

<script setup lang="ts">
import { inject } from 'vue';
import { Translator } from 'js/shims-vue';
import Card from 'vcomponents/common/card/Card.vue';
import TranslationText from 'vcomponents/common/TranslationText.vue';
import VideoPreview from 'vcomponents/common/VideoPreview/VideoPreview.vue';
import { type TranslationPart, useTranslationLinkParser } from 'composables/useTranslationLinkParser';

const $t = inject('$t') as Translator;

const { parseTranslation } = useTranslationLinkParser();

const illustrationSrc = '/ressources/logged/img/icon/svg/quickpay-pitch-illustration.svg';
const videoUrl = 'https://vimeo.com/1174824354/0c1d7a551e';

const translations: Record<string, string> = {
    title: $t.__('quickpay.settings.pitch.title'),
};

const descriptionParts: TranslationPart[] = parseTranslation(
    $t.__('quickpay.settings.pitch.description'),
);
</script>

<style lang="scss" scoped>
.quickpay-pitch {
    /* Override default card padding */
    &.quickpay-pitch {
        padding: 40px;
    }
    display: flex;
    gap: 40px;
    align-items: start;
    overflow: hidden;

    &__text {
        width: 302px;
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        gap: var(--spacing-3);
    }

    &__title {
        margin: 0;
        color: var(--colors-sellsy-brand-secondary-blue);
    }

    &__description {
        margin: 0;
        color: var(--colors-sellsy-brand-secondary-blue);
    }

    &__preview {
        flex: 1;
        height: 213px;
        overflow: hidden;
        border-radius: var(--spacing-1);
    }

}
</style>
